import AnimatedComponent from "./animatedComponent"

class ButtonBurger extends AnimatedComponent {
    constructor(element, options = {}) {
        if (!element) {
            console.error('element is empty')
            return false
        }

        let state_list = {
            icon: ['line', 'cross'],
        }
        let state_active_list = {
            icon: 'line',
        }

        super(element, state_list, state_active_list, null, options)

        let options_default = {
            // ...
        }
        this.options = {...options_default, ...options}
    }

    setState(icon_state) {
        this.changeState('icon', icon_state, this.element, true)
    };

    getElement() {
        return this.element
    }

    open() {
        this.setState('line')
    }

    close() {
        this.setState('cross')
    }
}

export default ButtonBurger